import React from "react";
import { Typography, Space } from "antd";
import GeneralCard from "@/components/card/GeneralCard";
import "@/styles/pages/common/termsandcondition.scss";
import DataDeletionRequestForm from "@/pages/dataRetentionPolicy/DataDeletionRequestForm";

const { Title, Paragraph, Link } = Typography;

const DataRetentionPolicy = () => {
  return (
    <div className="data-retention-policy-wrapper">
      <GeneralCard>
        <div className="data-retention-policy container">
          <Space direction="vertical" size="medium" className="policy-space">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 20px",
              }}
            >
              <div style={{ flex: "0 1 auto" }}></div>
              <div style={{ flex: "0 1 auto", textAlign: "right" }}>
                <div style={{ fontSize: "14px" }}>Inforens Global Ltd</div>
                <div style={{ fontSize: "14px" }}>Companies House Number: 13915242</div>
              </div>
            </div>

            <Title level={2} className="center" style={{ marginBottom: "35px" }}>
              Data Retention Policy
            </Title>

            <Paragraph>
              In accordance with the UK General Data Protection Regulation (UK GDPR) and data
              protection laws, Inforens Global Ltd has established the following data retention
              policy:
            </Paragraph>

            <Title level={4}>1. Types of Data Collected</Title>
            <Paragraph>
              Inforens Global Ltd collects and processes the following personal information:
              <ul style={{ listStyleType: "disc" }}>
                <li>Name</li>
                <li>Phone number</li>
                <li>Address</li>
                <li>Email address</li>
                <li>Bank account details</li>
                <li>Employee/intern/volunteer data</li>
                <li>Client data</li>
              </ul>
            </Paragraph>

            <Title level={4}>2. Purpose of Data Collection</Title>
            <Paragraph>
              Personal information is collected for the following purposes:
              <ul style={{ listStyleType: "disc" }}>
                <li>Payroll processing</li>
                <li>Reimbursements</li>
                <li>Client service and support</li>
                <li>Contractual obligations</li>
                <li>Legal obligations</li>
                <li>Vital interests</li>
                <li>Public tasks</li>
                <li>Legitimate interests</li>
              </ul>
            </Paragraph>

            <Title level={4}>3. Data Storage and Access</Title>
            <Paragraph>
              All personal information is securely stored and accessed only by authorized personnel,
              including:
              <ul style={{ listStyleType: "disc" }}>
                <li>The CEO/Founder</li>
                <li>Relevant department managers</li>
              </ul>
            </Paragraph>

            <Title level={4}>4. Retention Period</Title>
            <Paragraph>
              Inforens Global Ltd will retain personal data for a period of six years after the last
              interaction with the individual. This retention period applies to all internal data
              related to supporters, clients, and the public.
            </Paragraph>

            <Title level={4}>5. Reasons for Six-Year Retention</Title>
            <Paragraph>
              The six-year retention period is maintained due to:
              <ul style={{ listStyleType: "disc" }}>
                <li>Contractual obligations</li>
                <li>Legal obligations</li>
                <li>Vital interests</li>
                <li>Public task requirements</li>
                <li>Legitimate interests</li>
              </ul>
            </Paragraph>

            <Title level={4}>6. Data Subject Rights</Title>
            <Paragraph>
              Under UK GDPR and data protection laws, individuals have the following rights:
              <ul style={{ listStyleType: "disc" }}>
                <li>Right of access: Request copies of your personal information.</li>
                <li>
                  Right to rectification: Request correction of inaccurate or incomplete
                  information.
                </li>
                <li>
                  Right to erasure: Request deletion of your personal information in certain
                  circumstances.
                </li>
                <li>
                  Right to restriction of processing: Request restriction of processing your
                  personal information in certain circumstances.
                </li>
                <li>
                  Right to object: Object to the processing of your personal information in certain
                  circumstances.
                </li>
                <li>
                  Right to data portability: Request the transfer of your personal information to
                  another organization or to yourself in certain circumstances.
                </li>
              </ul>
            </Paragraph>

            <Title level={4}>7. Exercising Data Subject Rights</Title>
            <Paragraph>
              Individuals can exercise their data protection rights by contacting Inforens Global
              Ltd at{" "}
              <Link href="mailto:legal@inforens.com" style={{ textDecoration: "underline" }}>
                legal@inforens.com
              </Link>
              . The company will respond to requests within one month, and there is no charge for
              exercising these rights.
            </Paragraph>

            <Title level={4}>8. Data Deletion</Title>
            <Paragraph>
              At the end of the six-year retention period, or upon valid request for erasure,
              Inforens Global Ltd will securely delete or anonymize the personal data in accordance
              with UK GDPR and data protection laws.
            </Paragraph>
            <DataDeletionRequestForm />

            <Title level={4}>9. Children's Data</Title>
            <Paragraph>
              Inforens Global Ltd does not knowingly collect or process data from children under the
              age of 13. If it is discovered that such data has been collected, it will be erased or
              processing will cease within a reasonable time.
            </Paragraph>

            <Title level={4}>10. Client Data</Title>
            <Paragraph>
              Client data will be treated with the same level of confidentiality and security as
              other personal data. It will be retained for six years after the last interaction or
              the end of the client relationship, whichever is later. This includes:
              <ul style={{ listStyleType: "disc" }}>
                <li>Client contact information</li>
                <li>Project details</li>
                <li>Communication records</li>
                <li>Financial transactions</li>
              </ul>
            </Paragraph>

            <Title level={4}>11. Policy Review</Title>
            <Paragraph>
              This data retention policy will be reviewed annually and updated as necessary to
              ensure compliance with UK GDPR and data protection laws.
            </Paragraph>

            <Title level={4}>12. Contact Information</Title>
            <Paragraph>
              For any questions or concerns regarding this data retention policy, please contact:
              <br />
              <br />
              Inforens Global Ltd
              <br />
              670 Finchley Road, Golders Green, London, NW11 7NP, U.K.
              <br />
              Phone: +44 7587039853
              <br />
              Email:{" "}
              <Link href="mailto:legal@inforens.com" style={{ textDecoration: "underline" }}>
                legal@inforens.com
              </Link>
            </Paragraph>
          </Space>
        </div>
      </GeneralCard>
    </div>
  );
};

export default DataRetentionPolicy;
